/*
 * Copyright (c) 2021 WIT Software. All rights reserved.
 *
 * WIT Software Confidential and Proprietary information. It is strictly forbidden for 3rd parties to modify, decompile,
 * disassemble, defeat, disable or circumvent any protection mechanism; to sell, license, lease, rent, redistribute or
 * make accessible to any third party, whether for profit or without charge.
 *
 */

import { useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import * as router from 'store/ducks/router';
import { StoreState } from '../store/store';

export function useLocationWithState(): {
  path: string;
  from?: string;
  state?: unknown;
  hash?: string;
} {
  const { hash, pathname, search } = useLocation();
  const from = useSelector(router.Selectors.from);
  const path = `${pathname}${search}`;
  const state = useSelector((store: StoreState) => router.Selectors.state(store, path));
  return { path, from, state, hash };
}
